<template>
  <div>
    <div id="header" class="header navbar-default">
      <div class="navbar-header mobile-header">
        <button
          type="button"
          class="navbar-toggle mobile-menu-btn"
          @click.stop="drawer = !drawer"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

        <router-link
          v-if="admin === 'false'"
          to="/app"
          class="navbar-brand mobile-brand"
        >
          <img
            class="mobile-logo"
            src="/assets/img/solo_icono.png"
            alt=""
          />
          <span class="mobile-brand-text">
            <b>MIXORA-OPT&nbsp;</b>
          </span>
        </router-link>
        <router-link
          v-if="admin === 'true'"
          to="/Admin"
          class="navbar-brand mobile-brand"
        >
          <img
            class="mobile-logo"
            src="/assets/img/solo_icono.png"
            alt=""
          />
          <span class="mobile-brand-text">
            <b>MIXORA-OPT&nbsp;</b>
          </span>
        </router-link>

        <ul class="navbar-nav navbar-right mobile-user-nav">
          <b-nav-item-dropdown
            menu-class="dropdown-menu-right"
            class="dropdown navbar-user mobile-user"
            no-caret
          >
            <template slot="button-content">
              <img :src="foto" alt="" />
              <b class="caret"></b>
            </template>
            <b-dropdown-item @click.prevent="editPerfil">{{
              $t("actions.editProfile")
            }}</b-dropdown-item>
            <b-dropdown-item
              v-if="hasSisterProductLink && admin === 'false'"
              @click.prevent="goToSisterProduct"
            >
              {{ $t("landing.visitProduct", { product: sisterProductName }) }}
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item @click.prevent="cerrarSesion">{{
              $t("actions.closeSession")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </ul>
      </div>
    </div>

    <v-navigation-drawer v-model="drawer" temporary fixed>
      <div class="text-center" style="margin-top: 10px;">
        <h1>MIXORA-OPT</h1>
      </div>
      <v-list nav tag="ul">
        <v-list-item-group
          v-model="group"
          active-class="app-nav-active"
        >
          <v-list-item tag="li">
            <a href="#" @click.prevent="colorMix">
              <i class="fa fa-fill-drip"></i> Color Mix
            </a>
          </v-list-item>

          <v-list-item tag="li">
            <a href="#" @click.prevent="misFormulas">
              <i class="fa fa-palette"></i> {{ $t("nav.MyFormulas") }}</a
            >
          </v-list-item>

          <v-list-item tag="li">
            <a href="#" @click.prevent="misSugerencias">
              <i class="fa fa-message mr-1 mr-md-0"></i>
              {{ $t("nav.MySuggestions") }}</a
            >
          </v-list-item>

          <v-list-item tag="li">
            <a href="#" @click.prevent="misNotificaciones">
              <i class="fa fa-bell"></i> {{ $t("nav.Notifications") }}
            </a>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";
import StorageMethods from "@/utils/StorageMethods.js";
import {
  resolveProductKey,
  resolveSisterProductKey,
  resolveSisterProductUrl,
} from "@/utils/productIdentity.js";

export default {
  name: "HeaderMobile",
  data() {
    return {
      pageOptions: PageOptions,
      auth: {},
      storage: new StorageMethods(),
      admin: "false",
      drawer: false,
      group: null,
      foto: null,
    };
  },
  computed: {
    sisterProductUrl() {
      return resolveSisterProductUrl();
    },
    hasSisterProductLink() {
      return Boolean(this.sisterProductUrl);
    },
    sisterProductName() {
      const sisterKey = resolveSisterProductKey(resolveProductKey());
      return this.$t(`landing.products.${sisterKey}.shortName`);
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    cerrarSesion() {
      const admin = localStorage.getItem("admin");
      this.storage.cleanSession();
      if (admin === "true") {
        this.$router.push("/Admin/Login");
      } else {
        this.$router.push("/Login");
      }
    },
    misFormulas() {
      this.drawer = false;
      this.$router.push("/MisFormulas");
    },
    colorMix() {
      this.drawer = false;
      this.$router.push("/app");
    },
    misSugerencias() {
      this.drawer = false;
      this.$router.push("/MisSugerencias");
    },
    misNotificaciones() {
      this.drawer = false;
      this.$router.push("/Notificaciones");
    },
    editPerfil() {
      if (this.admin === "true") {
        this.$router.push("/Admin/Profile");
      } else {
        this.$router.push("/Profile");
      }
    },
    goToSisterProduct() {
      if (this.sisterProductUrl) {
        window.open(this.sisterProductUrl, "_blank", "noopener,noreferrer");
      }
    },
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("persona")) || {};
    this.foto = this.auth.Foto || this.auth.URLFoto;
    this.admin = localStorage.getItem("admin");
  },
};
</script>

<style scoped>
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 50px;
  padding: 0 8px;
}

.mobile-menu-btn {
  margin: 0;
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.mobile-brand {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 4px 0;
  flex: 1;
  justify-content: center;
}

.mobile-logo {
  height: 24px;
  width: 24px;
  margin-right: 8px;
}

.mobile-brand-text {
  font-size: 14px;
}

.mobile-user-nav {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.mobile-user {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.mobile-user img {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
